import { generatePath } from 'react-router-dom';

import { PaymentStatusEnum } from '@newModels';
import { checkoutPayment, checkoutPaymentStatus } from '@urls';

interface Payload {
  orderId: number,
  paymentAmount?: string | null,
  paymentStatus?: PaymentStatusEnum | null,
}

export const getOrderPaymentPathname = ({
  orderId,
  paymentAmount,
  paymentStatus,
}: Payload) => {
  const orderPaymentPathname = generatePath(checkoutPayment, { orderId });
  const orderPaymentStatusPathname = generatePath(checkoutPaymentStatus, { orderId });
  const paymentPathname = paymentStatus === PaymentStatusEnum.NotPaid && !!parseInt(paymentAmount || '0')
    ? orderPaymentPathname
    : orderPaymentStatusPathname;
  
  return paymentPathname;
};
